import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

type JoinClassNameValue =
  | string
  | number
  | false
  | null
  | undefined
  | JoinClassNameValue[]
  | Record<string, unknown>;

export const joinClassNames = (...classNames: JoinClassNameValue[]): string =>
  classNames
    .flatMap((className) => {
      if (!className) return [];
      if (Array.isArray(className)) return joinClassNames(...className);
      if (typeof className === "object") {
        return Object.entries(className)
          .filter(([, enabled]) => Boolean(enabled))
          .map(([name]) => name);
      }

      return String(className);
    })
    .filter(Boolean)
    .join(" ");

export const cx = cn;
